import React, { useEffect, useState } from "react";
import {
  getPOInvoice as getPOInvoiceAction
} from "./../../actions/project-management.action";
import { VENDOR_PAYMENT } from "../../constants/route-paths";
import "./scss/style.scss";
import idx from "idx";
import { resolveProjectType } from "../projects/utils/resolve-project-type";
import { format } from "date-fns";
import { numberFormat } from "../../util/currency-formatter";
import { isInlineItem, INLINE_CATALOG_DISPLAY_NAME } from "../../util/common";
import { withRouter } from "../../util/with-router";
import '../projects/scss/task.scss'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Table from 'react-bootstrap/Table';
import { getOnlyProjectData } from "../projects/utils/get-project";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { GSTORVAT } from 'src/util/enums';
import { roundValue, toDecimal } from '../../util/decimal-utils';
import Button from 'react-bootstrap/Button';


function ViewPO(props) {
  const [invoiceData, setInvoiceData] = useState([]);
  const [items, setItems] = useState([]);
  const [vendorType, setVendorType] = useState("");
  const [projectId, setProjectId] = useState(null);

  const dispatch = useDispatch()
  const { projectDetail = {}, project: projectState } = useSelector(state => state)

  const invoiceId = props.params.invoiceId;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");

    if (id && id !== "null") {
      setProjectId(id);
    } else {
      setProjectId(null);
    }
    if (invoiceId) {
      getPOInvoice(invoiceId);
    }

    if (!idx(projectDetail, _ => _.project.res) && id && id !== "null")
      getOnlyProjectData({ projectId: id, dispatch })
  }, [invoiceId]);

  const getPOInvoice = async (invoiceId) => {
    let invoice;
    invoice = await dispatch(getPOInvoiceAction(invoiceId)).catch(e => { });

    const items = idx(invoice, (_) => _.items) || [];
    const vendorType = idx(invoice, (_) => _.purchaseOrder.vendor.type);
    const isSubContractor = vendorType === "sub-contractor";

    let calculatedInvoiceClaim = roundValue(invoice.invoiceClaim, 2);
    if (isSubContractor) {
      if (Array.isArray(items) && items.length > 0) {
        calculatedInvoiceClaim = roundValue(
          items.reduce(
            (sum, item) => sum.plus(toDecimal(item.claimAmount || 0)),
            toDecimal(0)
          ),
          2
        );
      } else if (calculatedInvoiceClaim === 0 && invoice.retentionReleasedAmount > 0) {
        calculatedInvoiceClaim = roundValue(invoice.retentionReleasedAmount, 2);
      }
    }

    const data = {
      /* fId is the PO number with project prefix and Suffix if null then default to po Number*/
      poId: idx(invoice, (_) => _.purchaseOrder.f_id) || idx(invoice, (_) => _.purchaseOrder.id),
      invoiceNo: invoice.invoiceNo,
      amountPaid: roundValue(invoice.amountPaid, 2),
      retentionAmount: roundValue(invoice.retentionAmount, 2),
      retentionReleasedAmount: roundValue(invoice.retentionReleasedAmount, 2),
      invoiceURL: invoice.invoiceURL,
      invoiceClaim: calculatedInvoiceClaim,
      invoiceDate: invoice.invoiceDate,
      dueDate: invoice.dueDate,
      approvedAmount: roundValue(invoice.approvedAmount, 2),
      subTotal: roundValue(invoice.subTotal, 2),
      taxAmount: roundValue(invoice.taxAmount, 2),
      isCreditInvoice: idx(invoice, _ => _.purchaseOrder.is_credit_invoice) || false,
      receiveCreditAmount: roundValue(idx(invoice, _ => _.purchaseOrder.receive_credit_amount) || 0, 2),
      progressClaimNumber: invoice.progress_claim_number,
      totalAmountClaimed: roundValue(invoice.totalAmountClaimed || 0, 2),
      totalApproved: roundValue(invoice.totalApproved || 0, 2),
      totalRetention: roundValue(invoice.totalRetention || 0, 2),
    };

    setItems(items);
    setVendorType(vendorType);
    setInvoiceData(data);
  };

  const cancelHandler = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get("type");
    const id = urlParams.get("id");
    const poId = urlParams.get("poId") || urlParams.get("poid");
    const returnTo = urlParams.get("returnTo");

    if (returnTo === "vendor-payment") {
      if (vendorType === "sub-contractor") {
        props.history(`/${VENDOR_PAYMENT}?project=${id}${poId ? `&woId=${poId}` : ""}`);
      } else {
        props.history(`/${VENDOR_PAYMENT}?project=${id}${poId ? `&poId=${poId}` : ""}`);
      }
    } else if (poId && type === "project") {
      if (vendorType === "sub-contractor") {
        props.history(`/projects/work-order/${id}/view/${poId}`);
      } else {
        props.history(`/projects/purchase-order/${id}/view/${poId}`);
      }
    } else if (id && type === "service") {
      props.history(`/${VENDOR_PAYMENT}?service=${id}`);
    } else if (id && type === "project") {
      props.history(`/${VENDOR_PAYMENT}?project=${id}`);
    } else if (type && poId) {
      props.history(`/${VENDOR_PAYMENT}?type=${type}&poId=${poId}`);
    } else {
      props.history(`/${VENDOR_PAYMENT}`);
    }
  };

  const viewProject = () => props.history(`/projects/view/${projectId}`)
  const viewProjectList = () => {
    let type = resolveProjectType(
      idx(projectDetail, _ => _.project.res.projectType) || new URLSearchParams(window.location.search).get("project-type"),
      projectState
    );
    props.history(`/projects?project-type=${type}`);
  }


  return (
    <div className="purchase-order-block" data-cy='vendor-payment-view-container'>
      <h2 className="content-heading text-uppercase">VENDOR PAYMENT VIEW</h2>
      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          {(new URLSearchParams(window.location.search).get("returnTab") || window.location.pathname.startsWith('/vendor')) ? (
            <>
              <Breadcrumb.Item onClick={() => props.history('/vendor/vendor-list')} data-cy='vendors-breadcrumb'>VENDORS</Breadcrumb.Item>
              <Breadcrumb.Item onClick={cancelHandler} data-cy='invoices-breadcrumb'>INVOICES</Breadcrumb.Item>
              <Breadcrumb.Item active data-cy='view-breadcrumb'>View</Breadcrumb.Item>
            </>
          ) : projectId ? (
            <>
              <Breadcrumb.Item onClick={viewProjectList} data-cy='projects-breadcrumb'>PROJECTS</Breadcrumb.Item>
              <Breadcrumb.Item onClick={viewProject} data-cy='project-breadcrumb'>{idx(projectDetail, _ => _.project.res.name)}</Breadcrumb.Item>
              <Breadcrumb.Item onClick={cancelHandler} data-cy='vendor-payment-breadcrumb'>VENDOR PAYMENT</Breadcrumb.Item>
              <Breadcrumb.Item active data-cy='view-breadcrumb'>View</Breadcrumb.Item>
            </>
          ) : (
            <>
              <Breadcrumb.Item onClick={cancelHandler} data-cy='vendor-payment-breadcrumb'>VENDOR PAYMENT</Breadcrumb.Item>
              <Breadcrumb.Item active data-cy='view-breadcrumb'>View</Breadcrumb.Item>
            </>
          )}
        </Breadcrumb>
      </div>

      <div className="row">
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='po-no'>
            <label>PO/WO</label>
            <p>{invoiceData.poId}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='invoice-no'>
            <label>Invoice No</label>
            <p>{invoiceData.invoiceNo}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='invoice-claim'>
            <label>Invoice Claim (ex GST)</label>
            <p>{numberFormat(invoiceData.invoiceClaim)}</p>
          </div>
        </div>
        {vendorType === "sub-contractor" && (
          <div className="col-lg-4 mt-3">
            <div className="view-block" data-cy='progress-claim'>
              <label>Progress Claim No</label>
              <p>{invoiceData.progressClaimNumber || '-'}</p>
            </div>
          </div>
        )}
        {vendorType === "Supplier" && (<>
          <div className="col-lg-4 mt-3">
            <div className="view-block" data-cy='sub-total'>
              <label>Sub Total (Ex. {GSTORVAT})</label>
              <p>{numberFormat(invoiceData.subTotal)}</p>
            </div>
          </div>
          <div className="col-lg-4 mt-3">
            <div className="view-block" data-cy='tax-amount'>
              <label>{GSTORVAT}</label>
              <p>{numberFormat(invoiceData.taxAmount)}</p>
            </div>
          </div>
          {invoiceData.isCreditInvoice && (
            <div className="col-lg-4 mt-3">
              <div className="view-block">
                <label>Credit Invoice</label>
                <p>{numberFormat(invoiceData.receiveCreditAmount)}</p>
              </div>
            </div>
          )}
        </>)
        }
        {vendorType === "sub-contractor" && (<div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='approved-amount'>
            <label>Approved Amount (ex GST)</label>
            <p>{numberFormat(invoiceData.approvedAmount)}</p>
          </div>
        </div>)}
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='amount-paid'>
            <label>Amount Payable</label>
            <p>{numberFormat(invoiceData.amountPaid)}</p>
          </div>
        </div>
        {vendorType === "sub-contractor" && (
          <>
            <div className="col-lg-4 mt-3">
              <div className="view-block" data-cy='retention-amount'>
                <label>Retention Held (This Claim)</label>
                <p>{numberFormat(invoiceData.retentionAmount)}</p>
              </div>
            </div>
            <div className="col-lg-4 mt-3">
              <div className="view-block" data-cy='retention-released-amount'>
                <label>Retention Released (This Claim)</label>
                <p>{numberFormat(invoiceData.retentionReleasedAmount)}</p>
              </div>
            </div>
          </>
        )}
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='invoice-date'>
            <label>Invoice Date</label>
            <p>{invoiceData && invoiceData.invoiceDate && format(new Date(invoiceData.invoiceDate), "dd/MM/yyyy")}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='due-date'>
            <label>Due Date</label>
            <p>{invoiceData && invoiceData.dueDate && format(new Date(invoiceData.dueDate), "dd/MM/yyyy")}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block text-left" data-cy='invoice-url'>
            <label>Invoice URL</label>
            <a
              href={invoiceData.invoiceURL}
              rel="noopener noreferrer"
              target="_blank"
              data-cy='invoice-url-link'
            >
              Invoice URL
            </a>
          </div>
        </div>
        <div className="col-12">
          <div className="material-list-block mt-4">
            <div className="table-responsive" data-cy='items-table-container'>
              <Table bordered className="table-create table-material table-material-ch" data-cy='items-table'>
                <thead>
                  <tr>
                    {vendorType === "Supplier" ? (
                      <>
                        <th data-cy='task-header'>Task</th>
                        <th data-cy='catalog-header'>Catalog</th>
                        <th data-cy='items-description-header'>Items Description</th>
                        <th data-cy='category-header'>Category</th>
                        <th data-cy='part-no-header'>Part No</th>
                        <th className="text-right" data-cy='unit-cost-header'>Unit Cost</th>
                        <th data-cy='ordered-quantity-header'>Ordered Quantity</th>
                        <th data-cy='received-quantity-header'>Received  Quantity</th>
                        <th data-cy='previous-inv-header'>Previous Inv</th>
                        <th data-cy='this-inv-header'>This Inv</th>
                        <th data-cy='uom-header'>UoM</th>
                        <th className="text-right" data-cy='total-header'>Total</th>
                      </>
                    ) : (
                      <>
                        <th className="w-auto" data-cy='task-header'>Task</th>
                        <th className="w-auto" data-cy='description-header'>Description</th>
                        <th className="w-auto text-right" data-cy='total-cost-header'>Total Cost</th>
                        <th className="text-right" data-cy='previous-inv-header'>Prev. Approved</th>
                        <th className="text-right" data-cy='this-inv-header'>This Claim</th>
                        <th className="text-right" data-cy='total-header'>This Approved</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {vendorType === "Supplier" ? (
                    <>
                      {(Array.isArray(items) && items.length && items.map((item, index) => (
                        <tr key={index} data-cy='task-row'>
                          <td data-cy='task-name'>{item.taskName}</td>
                          <td data-cy='catalog-name'>{isInlineItem(item) ? INLINE_CATALOG_DISPLAY_NAME : item.category}</td>
                          <td data-cy='items-description-row'>{item.item}</td>
                          <td data-cy='manufacturer-name'>{item.manufacturer}</td>
                          <td data-cy='part-no'>{item.partNo}</td>
                          <td className="text-right" data-cy='unit-cost'>{numberFormat(item.cost)}</td>
                          <td data-cy='ordered-quantity'>{item.qty}</td>
                          <td data-cy='received-quantity'>{item.receivedQty}</td>
                          <td data-cy='previous-inv'>{numberFormat(invoiceData.totalAmountClaimed)}</td>
                          <td data-cy='this-inv'>{item.invoicedQty}</td>
                          <td data-cy='uom'>{item.unit}</td>
                          <td className="text-right" data-cy='total'>{numberFormat(item.amountPaid)}</td>
                        </tr>
                      ))) || (
                          <tr data-cy='no-items-to-show'>
                            <td colSpan={12} className="text-center" data-cy='no-items-to-show-row'> No Items to Show</td>
                          </tr>
                        )}
                    </>
                  ) : (
                    <>
                      {(Array.isArray(items) && items.length && items.map((item, index) => (
                        <tr key={index} data-cy='task-row'>
                          <td data-cy='task-name'>{item.taskName}</td>
                          <td data-cy='description'>{item.name || '-'}</td>
                          <td className="text-right" data-cy='total-cost'>{numberFormat(item.total)}</td>
                          <td className="text-right" data-cy='previous-inv'>{numberFormat(item.previousInv)}</td>
                          <td className="text-right" data-cy='this-inv'>{numberFormat(item.claimAmount)}</td>
                          <td className="text-right" data-cy='total'>{numberFormat(item.approvedAmount)}</td>

                        </tr>
                      ))) || (
                          <tr data-cy='no-items-to-show'>
                            <td colSpan={6} className="text-center" data-cy='no-items-to-show-row'> No Items to Show</td>
                          </tr>
                        )}
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 d-flex mt-5 justify-content-end">
        <Button onClick={cancelHandler} className="secondarybtn cancelbtn">Back</Button>
      </div>
    </div>
  );
}

export default withRouter(ViewPO);
